import React, { useEffect, useRef, useState } from 'react';
import styles from './UploadImage.module.scss';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import InputCustom from '../InputCustom/InputCustom';
import PrevImage from '../PrevImage/PrevImage';
import { uploadFile } from '../../../redux/actions/app/uploadFile';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { resetUploadFile } from '../../../redux/slices/app.slice';
const UploadImage = ({ form, name, size = '120px', label, font = '16px', errorCustom, required = true }) => {
  const {
    uploadFile: { data: uploadFileData, loading: uploadFileLoading },
  } = useSelector((state) => state.app);
  const refFile = useRef();
  const dispatch = useDispatch();
  const imageError = form.formState.errors?.[name];
  useEffect(() => {
    if (uploadFileData) {
      form.clearErrors(name);
      form.setValue(name, uploadFileData?.url);
      dispatch(resetUploadFile());
    }
  }, [uploadFileData]);
  return (
    <>
      <Box sx={{ position: 'relative', mb: 2, alignItems: 'start', display: 'flex', flexDirection: 'column', maxWidth: size, gap: 0.5 }}>
        <PrevImage form={form} name={name} label={label} />
        <Button
          disabled={uploadFileLoading}
          sx={{ width: '100%' }}
          onClick={() => {
            refFile.current.click();
          }}
          color={imageError ? 'error' : 'primary'}
          size="small"
          variant="outlined">
          Загрузить
        </Button>
        {imageError && <Box sx={{ color: 'error.main', fontSize: '12px' }}>Загрузите логотип</Box>}
        {uploadFileLoading && (
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
      <input
        style={{ display: 'none', width: 0, height: 0 }}
        ref={refFile}
        accept="image/*,video/*"
        multiple="false"
        type="file"
        onChange={(e) => {
          if (e.target.files[0]) {
            const formData = new FormData();
            formData.append('file', e.target.files[0]);
            dispatch(uploadFile(formData));
          }
        }}
      />
    </>
  );
};

export default UploadImage;
